<template>
    <label :class="[$style['mds-checkbox'], classObject, sizeClass]" :data-mds-version="version">
        <input
            ref="input"
            v-bind="$attrs"
            :checked="checked"
            type="checkbox"
            :value="value"
            :class="$style['mds-checkbox__input']"
            @change="$emit('change', $event.target.checked, $event)"
        />
        <span :class="$style['mds-checkbox__visible-wrap']">
            <span :class="$style['mds-checkbox__visual']">
                <mds-icon name="check" :class="$style['mds-checkbox__checked-icon']" :size="iconSize" />
                <mds-icon name="minus" :class="$style['mds-checkbox__indeterminate-icon']" :size="iconSize" />
            </span>
            <span :class="$style['mds-checkbox__text']">
                <slot>{{ label }}</slot>
                <span v-if="microcopy" :class="$style['mds-checkbox__microcopy']" v-html="microcopy"></span>
            </span>
        </span>
    </label>
</template>

<script>
    import MdsIcon from '@mds/icon';

    // Import component's API
    import MdsCheckboxProps from './checkbox_props.js';

    export default {
        name: 'MdsCheckbox',
        inheritAttrs: false,
        components: {
            MdsIcon,
        },
        model: {
            prop: 'checked',
            event: 'change',
        },
        props: MdsCheckboxProps,
        computed: {
            sizeClass() {
                return this.$style[`mds-checkbox--${this.size}`];
            },
            classObject() {
                const obj = {};
                obj[this.$style['mds-checkbox--hide-label']] = this.hiddenLabel;
                obj[this.$style['mds-component--on-dark']] = this.onDark;

                return obj;
            },
            iconSize() {
                return this.size === 'small' || this.size === 'medium' ? 'small' : 'medium';
            },
        },
        watch: {
            indeterminate() {
                this.$refs.input.indeterminate = this.indeterminate;
            },
        },
        mounted() {
            this.$refs.input.indeterminate = this.indeterminate;
        },
    };
</script>

<style lang="scss" module>
    @import './checkbox.scss';
</style>
